export default __webpack_public_path__ + "static/media/b20.5ae3da7e.jpg";